// useGeolocation.js
import { useState, useEffect } from 'react';

const useGeolocation = () => {
    const [location, setLocation] = useState({ lat: null, lng: null });
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!navigator.geolocation) {
            setError("Geolocation is not supported by your browser");
            return;
        }

        const success = (position) => {
            const { latitude, longitude } = position.coords;
            setLocation({ lat: latitude, lng: longitude });
        };

        const handleError = (error) => {
            setError(error.message);
        };

        navigator.geolocation.getCurrentPosition(success, handleError);
    }, []);

    return { location, error };
};

export default useGeolocation;